module.exports = __webpack_public_path__ + "img/LR-anwendungsgebiete_IMMUNSYSTEM_startseite-hintergrund.22b2a76e.jpg";